<template>
    <Modal class="trantemplate-modal"
           :width="500"
           :title="listType === 'multi'?'添加告警规则':'告警规则配置'"
           v-model="modal"
           @on-cancel="cancel"
           :mask-closable="false">
        <Form ref="form"
              :label-width="listType === 'multi'?100:20"
              :model="formData"
              :rules="rules">
            <FormItem label="告警规则:"
                      v-if="listType === 'multi'"
                      prop="alarm">
                <Select v-model="formData.alarm"
                        multiple
                        filterable
                        style="width:250px;">
                    <Option v-for="item in alarms1"
                            :value="item.id"
                            :key="item.id">{{ item.name }}</Option>
                </Select>
                <span class="icon-refresh-o-2 item-config-refresh"
                      @click="refresh"></span>
                <div class="mar-top5">
                    如果沒有可用的告警规则，点击&nbsp;
                    <router-link target="_blank"
                                 :to="{path:'/mgt/alarmrule/create'}">
                        <i class="icon-plus-o-1"></i>创建告警规则</router-link>
                </div>
            </FormItem>
            <FormItem label=""
                      v-if="listType === 'single'">
                <Transfer :data="alarms"
                          :target-keys="targetKeys1"
                          :render-format="render1"
                          :titles="titles"
                          @on-change="handleChange1"></Transfer>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button @click="cancel"
                    class="ivu-btn-text">取消</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">{{loading ? '保存中' : '保存'}}</Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api'
import {
    isNullOrEmpty
} from '@/service/utils'
export default {
    name: 'alarmtem',
    data () {
        return {
            loading: false,
            modal: false,
            targetKeys1: [],
            envType: '',
            defEnvType: '',
            titles: ['未配置', '已配置'],
            resid: '',
            listType: 'multi',
            alarms: [],
            alarms1: [],
            hasAlarms: [],
            formData: {
                alarm: []
            },
            exsitedData: [],
            rules: {}
        }
    },
    methods: {
        refresh () {
            this.getAlarms(this.defEnvType)
        },
        // 获取告警列表
        getAlarms (envType) {
            return new Promise((resolve) => {
                this.axios.get(this.urlFormat(API.GET_ALARMRULE_GRID, true), { params: { metricCategory: envType } }).then(res => {
                    const mockData = []
                    this.alarms1 = []
                    // 数据从监控返回，必定有dataList
                    res.dataList.forEach((r, i) => {
                        mockData.push({
                            id: r.id,
                            key: r.id,
                            label: r.name,
                            name: r.name,
                            description: r.description,
                            alarmRuleStrategies: r.alarmRuleStrategies,
                            disabled: false
                        })
                        let isOk = true
                        this.exsitedData.forEach(item => {
                            if (r.id === item.id || r.id === item.key) {
                                isOk = false
                            }
                        })
                        if (isOk) {
                            this.alarms1.push({
                                id: r.id,
                                name: r.name
                            })
                        }
                    })
                    this.alarms = mockData
                    resolve()
                })
            })
        },
        // 获取已有告警列表
        getHasAlarms () {
            return new Promise((resolve) => {
                this.axios.get(this.urlFormat(API.GET_ALARM_RESID, true, [this.resid])).then(res => {
                    this.hasAlarms = res
                    this.hasAlarms.length > 0 && this.alarms.forEach((r, i) => {
                        this.hasAlarms.forEach((r1, i1) => {
                            r.id === r1.id && (r.disabled = true)
                        })
                    })
                    resolve(res)
                })
            })
        },
        openModelDef (envType, alarms) {
            this.defEnvType = envType
            // 设置默认值
            this.formData.alarm = []
            if (!isNullOrEmpty(alarms)) {
                this.exsitedData = JSON.parse(alarms)
            } else {
                this.formData.alarm = []
            }
            this.getAlarms(envType)
            this.modal = true
        },
        openModal (envType, type, resid) {
            this.resid = resid
            this.listType = type
            this.envType = envType
            if (type === 'single') {
                this.axios.get(this.urlFormat(API.GET_ALARM_RESID, true, [this.resid])).then(res => {
                    const arr = res.map(item => { return item.id })
                    this.targetKeys1 = arr
                })
                this.getAlarms(envType)
            } else {
                this.getAlarms(envType)
            }
            this.modal = true
            this.$nextTick(() => {
                !this.envType && this.$refs.form && this.$refs.form.resetFields()
            })
        },
        render1 (item) {
            return item.label
        },
        handleChange1 (newTargetKeys, direction, moveKeys) {
            this.targetKeys1 = newTargetKeys
        },
        submit () {
            this.loading = true
            if (!this.resid) {
                this.loading = false
                const alarms = this.alarms.filter(item => {
                    let s = false
                    this.formData.alarm.forEach((r, i) => {
                        r === item.key && (s = true)
                    })
                    return s
                })
                this.$emit('getAlarms', alarms)
                this.modal = false
                return false
            } else {
                let data = {}
                if (this.listType === 'multi') {
                    data = {
                        targetType: 'instance',
                        ruleIds: this.formData.alarm,
                        ruleTargets: this.resid
                    }
                } else {
                    data = {
                        targetType: 'instance',
                        ruleIds: this.targetKeys1,
                        ruleTargets: this.resid
                    }
                }
                this.axios.post(this.urlFormat(API.POST_ALARMS_TARGETS, true), data).then(res => {
                    this.loading = false
                    this.$emit('refresh')
                    this.cancel()
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        cancel () {
            this.envType = ''
            this.alarms = []
            this.targetKeys1 = []
            this.modal = false
        }
    }
}
</script>
